import mainApi from "../../../../../../../assets/api/MainApi";

export const fetchItem = (shopId, id) => {
    return mainApi.getHeaderLink({
        shop_id: shopId,
        _id: id,
    });
};

export const createItem = (shopId, formData) => {
    return mainApi.createHeaderLink({
        shop_id: shopId,
        ...formData,
    });
};

export const editItem = (shopId, formData) => {
    return mainApi.editHeaderLink({
        shop_id: shopId,
        ...formData,
    });
};